import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'isAfterActive',
  standalone: true,
})
export class IsAfterActivePipe implements PipeTransform {
  transform(items: {active: boolean}[], index: number): boolean {
    const activeIndex = items.findIndex(i => i.active);
    return activeIndex >= 0 && index > activeIndex;
  }
}
